import { Component, Input } from '@angular/core';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { TableSortModel } from '../../../shared/tablesort/tableSortModel';
import { Router } from '@angular/router';
import { ComparatorService } from '../../../shared/services/comparator-service';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { AbstractComponent } from '../../../shared/components/abstract-component/abstract.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { BauprojektListEntry, GwrGrundstueckNummerListEntry } from '../../../core/gwr-api';
import { ListLoaderWrapperComponent } from '../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { ColumnHeaderComponent } from '../../../shared/tablesort/sort-icon/column-header.component';
import { LinkComponent } from '../../../shared/components/link/link.component';
import { KompaktGwrGrundstueckPipe } from '../../../shared/kompaktdarstellung/gwr/kompakt-gwr-grundstueck.pipe';

@Component({
  selector: 'cap-gwr-bauprojekt-table',
  templateUrl: './gwr-bauprojekt-table.component.html',
  styleUrls: ['./gwr-bauprojekt-table.component.scss'],
  imports: [ListLoaderWrapperComponent, NgTemplateOutlet, ColumnHeaderComponent, LinkComponent, TranslatePipe, KompaktGwrGrundstueckPipe]
})
export class GwrBauprojektTableComponent extends AbstractComponent {
  @Input()
  title = 'GefundeneBauprojekte';

  @Input()
  showZeilenSelect = true;

  @Input()
  showTotal = true;

  private _listLoader: ListLoader<BauprojektListEntry>;

  tableSortModel = new TableSortModel<BauprojektListEntry>('table', this.comparatorService);

  maxGrundstueckeProBauprojekt = 3;

  private EPROID = 'eproid';
  private AMTLICHE_BAUDOSSIERNUMMER = 'amtlicheBaudossiernummer';
  private GRUNDSTUECKE = 'grundstuecke';
  private PROJEKTSTATUS = 'projektstatus';
  private PROJEKTUMSCHREIBUNG = 'projektumschreibung';

  constructor(
    protected router: Router,
    protected comparatorService: ComparatorService,
    private translate: TranslateService
  ) {
    super();
    keysToTranslate<string>(['Grundstuecke', 'Projektumschreibung', 'GefundeneBauprojekte', 'Grundstücke']);
    keysToTranslate<BauprojektListEntry.ProjektstatusEnum>([
      'BAUGESUCH_BEANTRAGT',
      'BAUBEWILLIGUNG_BEWILLIGT',
      'PROJEKT_BAUBEGONNEN',
      'PROJEKT_ABGESCHLOSSEN',
      'PROJEKT_SISTIERT',
      'BAUGESUCH_ABGELEHNT',
      'PROJEKT_NICHT_REALISIERT',
      'PROJEKT_ZURUECKGEZOGEN'
    ]);
    this.tableSortModel
      .addColumn(this.EPROID, (a, b) => this.comparatorService.orderByComparator(a.eproid.value, b.eproid.value), null)
      .switchSortDirection();
    this.tableSortModel.addColumn(
      this.AMTLICHE_BAUDOSSIERNUMMER,
      (a, b) => this.comparatorService.orderByComparator(a.amtlicheBaudossiernummer, b.amtlicheBaudossiernummer),
      null
    );
    this.tableSortModel.addColumn(
      this.GRUNDSTUECKE,
      (a, b) => {
        if (a.grundstuecke) {
          return this.comparatorService.gwrGrundstueckComparator(a.grundstuecke[0], b.grundstuecke[0]);
        }
        return 0;
      },
      null
    );
    this.tableSortModel.addColumn(
      this.PROJEKTSTATUS,
      (a, b) => this.comparatorService.orderByComparator(this.translate.instant(a.projektstatus), this.translate.instant(b.projektstatus)),
      null
    );
    this.tableSortModel.addColumn(
      this.PROJEKTUMSCHREIBUNG,
      (a, b) => this.comparatorService.orderByComparator(a.projektumschreibung, b.projektumschreibung),
      null
    );
  }

  @Input()
  set listLoader(value: ListLoader<BauprojektListEntry>) {
    if (!value) {
      return;
    }
    value.applySortModel(this.tableSortModel);
    this._listLoader = value;
  }

  get listLoader(): ListLoader<BauprojektListEntry> {
    return this._listLoader;
  }

  getGrundstueckQueryParams(grundstueckNummer: GwrGrundstueckNummerListEntry) {
    const params = [];
    params['bfs'] = grundstueckNummer.gemeinde && grundstueckNummer.gemeinde.bfsNummer;
    params['n1'] = grundstueckNummer.nummer;
    params['n2'] = grundstueckNummer.nummerZusatz;
    params['n3'] = grundstueckNummer.nummer3;
    params['n4'] = grundstueckNummer.nummer4;
    return params;
  }
}
